import { FunctionComponent, useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';
import { UserContext } from '../../context';
import { useUserByIdQuery } from '../../services';
import { NoContent } from '../Error';
import { Profile } from './Profile';
import { ProfileFeed } from './ProfileFeed';
import { UserFeedAdmin } from './UserFeedAdmin';

import classes from './Profile.module.scss';

export const ProfileOtherAdmin: FunctionComponent = () => {
  const { profileId } = useParams();

  const { data: profileOther, isLoading } = useUserByIdQuery({
    userId: Number(profileId),
  });

  const { userInfo } = useContext(UserContext);

  if (isLoading) {
    return <Skeleton height={'10rem'} />;
  }

  if (!profileOther) {
    return <NoContent />;
  }

  const {
    id: userId,
    avatar,
    screenName,
    roleId,
    bio,
    links,
    url,
    leaderBoardBadge,
  } = profileOther;

  const { channelId } = userInfo.userData;

  return (
    <>
      <Profile
        userId={userId}
        me={false}
        roleId={roleId}
        avatar={avatar}
        screenName={screenName}
        bio={bio}
        links={links}
        url={url}
        leaderBoardBadge={leaderBoardBadge}
      />

      <div className={classes['profile__feeds-wrapper']}>
        <ProfileFeed userId={userId} me={false} />
        <UserFeedAdmin channelId={channelId} userId={userId} me={false} />
      </div>
    </>
  );
};
